@if (isLoading()) {
    <app-loading />
} @else {
    @if (!data().length) {
        <app-no-data-to-display [displayedMessage]="'noReferenceDataToDisplay'" />
    } @else {
        <app-tab
            [activeTabColor]="'bg-custom-light-grey'"
            [defaultTabIndex]="selectedTabIndex()"
            [isSimpleTabStyle]="true"
            [tabs]="themeTabs()"
            [tabsBadge]="tabsBadge()"
            [translateTabs]="false"
            (changeTab)="changeTab($event)">
            @for (item of depositFoldersByTopic(); track item.topicName) {
                <ng-template appTabContent>
                    <div class="max-h-[35vh] bg-custom-light-grey rounded-lg p-2.5 overflow-y-auto">
                        @for (data of item.depositFolders; track data.id) {
                            <div class="mb-2 bg-white">
                                <app-expansion-panel [isExpanded]="false">
                                    <div
                                        class="w-full"
                                        header
                                        (click)="toggleDataSelected(data)">
                                        <app-selectable-header
                                            [checked]="addLayerService.selectedDepositFolder()?.id === data.id"
                                            [containerClass]="'mt-2'"
                                            [label]="data.name"
                                            [radioClass]="'mb-2 mr-2'"
                                            (selected)="toggleDataSelected(data)" />
                                    </div>

                                    <div
                                        class="w-11/12 m-auto"
                                        content>
                                        <div class="flex flex-row justify-between items-center w-full m-auto">
                                            <p>{{ 'description' | transloco }}</p>
                                            <p>
                                                {{ data.depositCount
                                                }}{{ 'deposit' | transloco: { COUNT: data.depositCount } }}
                                            </p>
                                        </div>
                                        <div class="min-h-0 flex-1 overflow-x-auto pb-4">
                                            <p class="text-custom-dark-grey text-sm font-normal">
                                                {{ data.metadata?.['description'] }}
                                            </p>
                                        </div>
                                    </div>
                                </app-expansion-panel>
                            </div>
                        } @empty {
                            <app-no-data-to-display [displayedMessage]="'noReferenceDataToDisplay'" />
                        }
                    </div>
                </ng-template>
            }
        </app-tab>
    }
}
